/** Material Symbols glyph. The font is loaded once in index.html. */
export default function Icon({ name, size, className = '', style, ...rest }) {
  return (
    <span
      className={`mi ${className}`}
      style={size ? { fontSize: size, ...style } : style}
      aria-hidden="true"
      {...rest}
    >
      {name}
    </span>
  );
}
